import { GTMWindow } from '../model';
import { getHref } from '../utils';
import { environment } from '@environments/environment';
import { PageTypes } from '@features/page/page.config';

export type PageViewEnvironment = 'dev' | 'prod';
export type PageViewDevice = 'mobile' | 'tablet' | 'desktop';
export type PageViewData = Pick<PageViewEvent, 'pageTitle' | 'pageType' | 'deviceType' | 'ogLocation' | 'guid'>;
export type PageViewType = Exclude<PageTypes, 'rootPage'> & 'frontPage';

export type PageViewEvent = {
    event: 'pageview';
    environment: PageViewEnvironment;
    deviceType: PageViewDevice;
    pageType: PageViewType; // use the same pages type as the umbraco alias with this we can track all the events
    pageTitle: string;
    pageUrl: string;
    ogLocation: string;
    guid: string;
};

export const trackPageViewEvent = (windowReference: GTMWindow, pageViewEvent: PageViewData): PageViewEvent => ({
    event: 'pageview',
    environment: environment.production ? 'prod' : 'dev',
    pageUrl: `${getHref(windowReference)}`,
    ...pageViewEvent,
    pageTitle: pageViewEvent.pageTitle || windowReference.document.title,
    guid: pageViewEvent.guid || ''
});
